import { styled } from "styled-components";
import {
  Arch,
  ArchStandaloneSectionWrapper,
} from "@template/blocks/ArchStandaloneSection/component/styles.ts";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 64px 24px;
  position: relative;

  > div {
    max-width: 1024px;
  }

  ${ArchStandaloneSectionWrapper} {
    position: absolute;
    left: 0;
    width: 100vw;
    max-width: revert;
    height: 100%;

    ${Arch} {
      top: 140px;
      width: 200%;
    }
  }
`;
